import axios from '../axios'

const deleteAnnouncementApi = async (announcementId) => {
  return await axios.delete(`api/lms/announcements/${announcementId}`)
}

export default deleteAnnouncementApi
